<div class="new-certificate-error-banner" *ngIf="message">
  <div class="new-certificate-error-banner__header">
    <span>{{ title }}</span>
    <button
      type="button"
      class="new-certificate-error-banner__close"
      (click)="onDismiss()"
      aria-label="Dismiss error"
    >
      x
    </button>
  </div>
  <div class="new-certificate-error-banner__body">{{ message }}</div>
</div>
